import HomeSmile from "@/assets/icons/home-smile.svg";
import AnimatedMount from "@/components/AnimatedMount";
import GrayRoundButton from "@/components/buttons/GrayRoundButton";
import NewMessageButton from "@/components/buttons/NewMessageButton";
import CenteredSpinner from "@/components/CenteredSpinner";
import AskVistaInput from "@/components/header/AskVistaInput";
import AssistantButton from "@/components/header/AssistantButton";
import SettingsDialog from "@/components/settings/SettingsDialog";
import UserAvatar from "@/components/UserAvatar";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import routes from "@/router/routes";
import assistantStore, { closeAssistant } from "@/stores/assistantStore";
import { useSelector } from "@tanstack/react-store";
import { useNavigate } from "react-router-dom";

const Header = () => {
    const navigate = useNavigate();
    const isAssistantOpen = useSelector(assistantStore, (s) => s.isOpen);
    const { data: user, isLoading: isUserLoading } = useGetUserProfile();

    if (!user || isUserLoading) {
        return <CenteredSpinner />;
    }

    const shouldHideAskVistaInput =
        window.location.pathname === routes.dashboard || isAssistantOpen;

    return (
        <header className="z-header fixed left-0 right-0 flex items-center justify-between px-12 py-3">
            <div className="flex w-full items-center justify-between gap-6">
                <div className="flex min-w-0 flex-1 items-center gap-6">
                    <div className="flex-shrink-0">
                        <GrayRoundButton
                            image={HomeSmile}
                            onClick={() => {
                                if (isAssistantOpen) {
                                    closeAssistant();
                                }
                                navigate(routes.dashboard);
                            }}
                        />
                    </div>
                    <div className="flex h-15 min-w-0 flex-1 items-center">
                        <AnimatedMount
                            className="w-full min-w-14 max-w-80"
                            shouldShow={!shouldHideAskVistaInput}
                        >
                            <AskVistaInput className="w-full" />
                        </AnimatedMount>
                    </div>
                </div>
                <div className="flex items-center gap-8">
                    {!isAssistantOpen && <AssistantButton />}
                    <NewMessageButton />
                    <SettingsDialog trigger={<UserAvatar user={user} />} />
                </div>
            </div>
        </header>
    );
};

export default Header;
